import {errorStore} from './ErrorStore';

export function initUncaughtErrorListener() {
  window.addEventListener('error', event => {
    const message = `Uncaught error: ${event.message}`;
    console.error(message);
    errorStore.addError(message);
  });

  window.addEventListener('unhandledrejection', event => {
    const message = event.reason ? `Uncaught promise rejection: ${String(event.reason)}` : 'Unknown Error';
    console.error(event.reason);
    errorStore.addError(message);
  });
}
